<template>
  <div class="flex gap-2 items-center bg-white rounded-lg p-3">
    <div class="flex-none w-[190px] flex-col">
      <h3 class="font-medium truncate" :title="this.heading">
        {{ this.heading }}
      </h3>
      <div class="flex gap-2 items-center">
        <Icon icon="bx:check-circle" height="20" class="text-emerald-600" />
        <p class="text-neutral-700">{{ stats.correctas }} correctas</p>
      </div>
    </div>
    <div class="flex-none w-[74px] flex-col text-center">
      <p class="text-neutral-700">{{ this.stats.correctas + this.stats.incorrectas }} Vistas</p>
      <div class="flex gap-1 items-center">
        <Icon
          icon="ant-design:thunderbolt-outlined"
          height="20"
          class="text-blue-600"
        />
        <p class="text-neutral-700">{{ stats.puntuacion }} pts</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import { MobCircularChart } from "@/views/V2/components";

export default {
  name: "StudentStatCard",
  components: {
    Icon,
    MobCircularChart,
  },
  props: {
    heading: String,
    stats: Object,
  },
  computed: {
    viewPercentage: function () {
      return Math.round(((this.stats.correctas) / (this.stats.correctas + this.stats.incorrectas)) * 100);
    },
  },
};
</script>
